import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from '$src/common/RangeInput.css'
import {asField} from '$src/common/forms'

interface Props {
  css?: any
  type?: 'text' | 'password'
  name: string
  label: string
  placeholder?: string
  value: undefined | null | {from: number; to: string | number}
  onChange: (v: any) => void
}

@observer
export default class RangeInput extends Component<Props, {}> {
  static Field: any

  _onFromChange = (e: any) => {
    const value = this.getCurrentValue()
    this.props.onChange({from: e.target.value, to: value.to})
  }

  _onToChange = (e: any) => {
    const value = this.getCurrentValue()
    this.props.onChange({to: e.target.value, from: value.from})
    // this.props.onChange(e.target.value)
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)
    const value = this.getCurrentValue()

    let isValid = this.isValid(value)

    return (
      <div {...classes('container', !isValid && 'invalid')}>
        <label {...classes('label')}>{props.label}</label>
        <div {...classes('inputs')}>
          <input
            {...classes('input', 'from')}
            type={props.type || 'text'}
            placeholder="from"
            value={value.from}
            onChange={this._onFromChange}
          />
          <input
            {...classes('input', 'to')}
            type={props.type || 'text'}
            placeholder="to"
            value={value.to}
            onChange={this._onToChange}
          />
        </div>
      </div>
    )
  }

  private isValid({from, to}: any) {
    if (from === '' && to === '') return true

    if (from !== '' && parseFloat(from) !== parseFloat(from)) return false
    if (to === '') return true

    if (!to.match(/^([0-9][0-9\.]*)\+?$/)) {
      return false
    }

    const numberOfFrom = parseFloat(from)


    if (to.match(/\+/)) {
      const toParts = to.match(/^([0-9][0-9\.]*)\+?$/)
      const numberOfTo = parseFloat(toParts[1])

      if (from !== '' && numberOfFrom > numberOfTo) return false
    } else {
      const numberOfTo = parseFloat(to)
      if (from !== '' && numberOfFrom > numberOfTo) return false
    }

    return true
  }

  getCurrentValue(props: any = this.props) {
    return props.value || {from: '', to: ''}
  }
}

RangeInput.Field = asField()(RangeInput)



// WEBPACK FOOTER //
// ./src/common/RangeInput.tsx